import { isAfter, isEqual, parse, format } from 'date-fns';
import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class BeneficiarioApi extends Api {
  async consultarNomes () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosBeneficiarios');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesMaisPensionista () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosBeneficiariosPensionista');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesServidoresSemVinculo () {
    try {
      const nomesUrl = resolve('urlConsultarNomesServidoresSemVinculo');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarIdade (codServidor, seqDependenteRH, dataReferencia) {
    try {
      const urlBeneficiarioIdade = resolve('urlBeneficiarioIdade') + codServidor + '/' +  seqDependenteRH + '/' + dataReferencia;
      const response = await this.fetch(urlBeneficiarioIdade);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarFluxo (filter) {
    try {
      const fluxoUrl = `${resolve('urlBeneficiarioConsultarFluxo')}/${filter.tipo}/${parse(filter.from)}/${parse(filter.to)}`
      const response = await this.fetch(fluxoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarFluxoCaixa (filter) {
    try {
      let fluxo = [];
      const fluxoUrl = `${resolve('urlBeneficiarioConsultarFluxo')}/${filter.tipo}/${parse(filter.from)}/${parse(filter.to)}`
      const { data } = await this.fetch(fluxoUrl);
      data.map(res => {
        const { titularidade, codServidor, dtaNascimento, sexo, nome, codTipoMensalidade, dtaInicio, dtaFim, numMatriculaTST, parentesco, 
          seqBeneficiario, seqDependente, numSeqDependenteRH, numCartaoCaixa} = res;
        fluxo.push(Object.values({ nome, numMatriculaTST, titularidade, parentesco, dtaNascimento, sexo, dtaInicio, dtaFim, numCartaoCaixa,
          codServidor, codTipoMensalidade, seqBeneficiario, seqDependente, numSeqDependenteRH
        }));
      });
      return fluxo || [];
    } catch (error) {
      console.error(error);
    }
  }
  async consultarBeneficiarioCaixa (carteira) {
    try {
      let fluxo = [];
      const fluxoUrl = resolve('urlBeneficiarioConsultarAlteracao') + carteira;
      const { data } = await this.fetch(fluxoUrl);
      data.map(res => {
        const { titularidade, codServidor, dtaNascimento, sexo, nome, codTipoMensalidade, dtaInicio, dtaFim, numMatriculaTST, parentesco, 
          seqBeneficiario, seqDependente, numSeqDependenteRH, numCartaoCaixa} = res;
        fluxo.push(Object.values({ nome, numMatriculaTST, titularidade, parentesco, dtaNascimento, sexo, dtaInicio, dtaFim, numCartaoCaixa,
          codServidor, codTipoMensalidade, seqBeneficiario, seqDependente, numSeqDependenteRH
        }));
      });
      return fluxo || [];
    } catch (error) {
      console.error(error);
    }
  }
  async consultarBeneficiarios (filtro) {
    let beneficiarios = [];
    const bolCarteira = /^([0-9]{5}-[0-9]{2})$/.test(filtro);
    const bolCodigoServidor = /^([cC]?[0]?[0-9]{1,5})$/.test(filtro);
    const bolNome = /^([ \u00c0-\u01ffa-zA-Z'-])+$/.test(filtro.toUpperCase());

    const filter = {
      carteira: bolCarteira ? filtro.toUpperCase() : 'vazio',
      codServidor: bolCodigoServidor ? filtro.toUpperCase() : 'vazio',
      nome: bolNome ? filtro.toUpperCase() : 'vazio'
    };

    try {
      const beneficiarioUrl = resolve('urlBeneficiarioConsultar') + filter.carteira + '/codServidor/' + filter.codServidor + '/nome/' + filter.nome;
      const { data } = await this.fetch(beneficiarioUrl);
      beneficiarios = data || [];
      return beneficiarios;
    } catch (error) {
      console.error(error);
    }

  }

  async consultarHistoricoAdesao (filter) {
    try {
      const historicoAdesaoUrl = resolve('urlHistoricoAdesaoConsultar') + filter.codServidor;
      const response = await this.fetch(historicoAdesaoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async incluirTitular (filter) {
    const incluirTitularUrl = resolve('urlIncluirTitular');
    const response = await this.fetch(incluirTitularUrl, 'put', filter);
    return response;
  }
  async incluirDependente (filter) {
    const incluirDependenteUrl = resolve('urlIncluirDependente');
    const response = await this.fetch(incluirDependenteUrl, 'put', filter);
    return response;
  }
  async excluirTitular (filter) {
    const excluirTitularUrl = resolve('urlExcluirTitular');
    const response = await this.fetch(excluirTitularUrl, 'put', filter);
    return response;
  }
  async exlcuirDependente (filter) {
    const excluirDependenteUrl = resolve('urlExcluirDependente');
    const response = await this.fetch(excluirDependenteUrl, 'put', filter);
    return response;
  }
  async alterarTitularidade (filter, codTitularidade) {
    var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
    const alterarTitularidadeUrl = resolve('urlAlterarTitularidade') + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/titularidade/' + codTitularidade;
    const response = await this.fetch(alterarTitularidadeUrl, 'put');
    return response;
  }

  async consultarDependencias (filter) {
    try {
      var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
      const urlDependencias = resolve('urlConsultarDependencias') + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/carteira/' + filter.numMatriculaTST + '/titularidade/' + filter.titularidade;
      const response = await this.fetch(urlDependencias, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return 'S';
    }
  }
  async salvarDataInicial (filter, data) {
    var dataNula = parse(new Date(null));
    var dtaParam = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
    const salvarDataInicialUrl = resolve('urlSalvarDataInicial') + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/data/' + dtaParam + '/titularidade/' + filter.titularidade;
    const response = await this.fetch(salvarDataInicialUrl, 'put');
    return response;
  }

  async salvarDataFim (filter, data) {
    var dataNula = parse(new Date(null));
    var dtaParam = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
    const salvarDataFimUrl = resolve('urlSalvarDataFim') + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/data/' + dtaParam + '/titularidade/' + filter.titularidade;
    const response = await this.fetch(salvarDataFimUrl, 'put');
    return response;
  }
  async consultarLimitesDataInicioTitular (filter, data) {
    try {
      const consultarLimitesDataInicioTitularUrl = resolve('urlConsultarLimitesDataInicioTitular') + filter.seqBeneficiario + '/codServidor/' + filter.codServidor + '/dataInicio/' + data;
      const response = await this.fetch(consultarLimitesDataInicioTitularUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async consultarLimitesDataInicioDependente (filter) {
    try {
      const consultarLimitesDataInicioDependenteUrl = resolve('urlConsultarLimitesDataInicioDependente') + filter.seqBeneficiario;
      const response = await this.fetch(consultarLimitesDataInicioDependenteUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async consultarLimitesDataFimTitular (filter, data) {
    var dataNula = '0';
    var dtaParam = data === null || data === '' ? dataNula : data;
    try {
      const consultarLimitesDataFimTitularUrl = resolve('urlConsultarLimitesDataFimTitular') + filter.seqBeneficiario + '/codServidor/' + filter.codServidor + '/dataFim/' + dtaParam;
      const response = await this.fetch(consultarLimitesDataFimTitularUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async consultarLimitesDataFimDependente (filter) {
    try {
      var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
      const consultarLimitesDataFimDependenteUrl = resolve('urlConsultarLimitesDataFimDependente') + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/carteira/' + filter.numMatriculaTST;
      const response = await this.fetch(consultarLimitesDataFimDependenteUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
  async validarDataInicio (data, dataFim, titularidade, indRegistroPossuiDependencias, dataInicioOriginal, dataInicioLimiteMinimo, dataInicioLimiteMaximo) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFim = dataFim === null ? dataNula : parse(parse(dataFim).setHours(0, 0, 0, 0));
    dataInicioOriginal = dataInicioOriginal === null ? dataNula : parse(parse(dataInicioOriginal).setHours(0, 0, 0, 0));
    dataInicioLimiteMinimo = dataInicioLimiteMinimo === null ? dataNula : parse(parse(dataInicioLimiteMinimo).setHours(0, 0, 0, 0));
    dataInicioLimiteMaximo = dataInicioLimiteMaximo === null ? dataNula : parse(parse(dataInicioLimiteMaximo).setHours(0, 0, 0, 0));

    if (isEqual(data, dataNula) || data === undefined || data.toString() === 'Invalid Date') {
      return 'A data não pode ser nula.';
    }
    if (!isEqual(data, dataNula) && !isEqual(dataFim, dataNula) && isAfter(data, dataFim)) {
      return 'A data não pode ser maior que a data Fim Adesão.';
    }
    // if (indRegistroPossuiDependencias === 'S' && isAfter(data, dataInicioOriginal)) {
    //   return 'Este beneficiário já possui guias vinculadas.';
    // }

    if (titularidade === 'SERVIDOR') {
      if (isAfter(dataInicioLimiteMinimo, data)) {
        return 'A data início não pode ser menor que a data fim dos últimos cadastros.';
      }
      if (isAfter(data, dataInicioLimiteMaximo)) {
        if (indRegistroPossuiDependencias === 'S'){
          // return 'A data início não pode ser maior que as datas início dos dependentes.';
        } else {
          // return 'A data início não pode ser maior que ' + format(dataInicioLimiteMaximo, 'DD/MM/YYYY');
        }        
      }
    } else {
      if (isAfter(dataInicioLimiteMinimo, data)) {
        return 'A data início não pode ser menor que a data início do titular.';
      }
      // if (isAfter(data, dataInicioLimiteMaximo)) {
      //   return 'A data início não pode ser maior que a data fim do titular.';
      // }
    }
    return '';
  }

  async validarDataFim (data, dataInicio, titularidade, dataFimLimiteMaximo) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFimLimiteMaximo = dataFimLimiteMaximo === null ? dataNula : parse(parse(dataFimLimiteMaximo).setHours(0, 0, 0, 0));

    if (!isEqual(data, dataNula) && isAfter(dataInicio, data)) {
      return 'A data não pode ser menor que a data Início Adesão.';
    }

    if (titularidade === 'SERVIDOR') {
      if (!isEqual(data, dataNula)) {
        if (!isEqual(dataFimLimiteMaximo, dataNula) && isAfter(data, dataFimLimiteMaximo)) {
          return 'A data fim não pode ser maior que as datas início dos outros cadastros.';
        }
      }
    }
    return '';
  }

  async consultarBeneficiarioInternado (carteira, dtaAtendimento) {
    try {
      const beneficiarioInternadoUrl = resolve('urlBeneficiarioInternado') + carteira + '/data_atendimento/' + dtaAtendimento;
      const response = await this.fetch(beneficiarioInternadoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarTelefones (codServidor, seqDependenteRH) {
    let telefones = [];

    try {
      const urlTelefonesBeneficiario = resolve('urlTelefonesBeneficiario') + codServidor + '/' + seqDependenteRH;
      const { data } = await this.fetch(urlTelefonesBeneficiario);
      data.map(res => {
        const { codTipoTelefone, desTipoTelefone, numDDD, numTelefone, txtObservacao } = res;
        telefones.push(Object.values({ numDDD, numTelefone, codTipoTelefone, desTipoTelefone, txtObservacao }));
      });
      return telefones || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarHistoricos (codServidor, seqDependenteRH) {
    let historicos = [];

    try {
      const urlHistoricosBeneficiario = resolve('urlHistoricosBeneficiario') + codServidor + '/' + seqDependenteRH;
      const { data } = await this.fetch(urlHistoricosBeneficiario);
      data.map(res => {
        const { titularidade, dtaInicio, dtaFim, fechamentoPeloSistema, fechamentoPorFalecimento, usuarioFechamento } = res;
        historicos.push(Object.values({ titularidade, dtaInicio, dtaFim, fechamentoPorFalecimento, usuarioFechamento }));
      });
      return historicos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarEmails (codServidor, seqDependenteRH) {
    let emails = [];
    try {
      const urlEmailsBeneficiario = resolve('urlEmailsBeneficiario') + codServidor + '/' + seqDependenteRH;
      const { data } = await this.fetch(urlEmailsBeneficiario);
      data.map(res => {
        const { idEmail, desEmail } = res;
        emails.push(Object.values({ idEmail, desEmail }));
      });
      return emails || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarEnderecos (codServidor, seqDependenteRH) {
    let enderecos = [];
    try {
      const urlEnderecosBeneficiario = resolve('urlEnderecosBeneficiario') + codServidor + '/' + seqDependenteRH;
      const { data } = await this.fetch(urlEnderecosBeneficiario);
      data.map(res => {
        const { idEndereco, desEndereco, bairro, cidade, siglaUF, CEP, numero, complemento } = res;
        enderecos.push(Object.values({ idEndereco, desEndereco, bairro, cidade, siglaUF, CEP, numero, complemento }));
      });
      return enderecos || [];
    } catch (error) {
      console.error(error);
    }
  }
  async consultarRequisitado (codServidor, seqDependenteRH) {
    let requisitado = [];
    try {
      const urlRequisitadoBeneficiario = resolve('urlRequisitadoBeneficiario') + codServidor + '/' + seqDependenteRH;
      const { data } = await this.fetch(urlRequisitadoBeneficiario);
      data.map(res => {
        const { codServidor, dtaInicio, dtaFim, carreira, orgaoExterno, txtObservacao } = res;
        requisitado.push(Object.values({ codServidor, dtaInicio, dtaFim, carreira, orgaoExterno, txtObservacao }));
      });
      return requisitado || [];
    } catch (error) {
      console.error(error);
    }
  }
  async consultarRequisitadoHistorico (codServidor, seqDependenteRH) {
    let requisitado = [];
    try {
      const urlRequisitadoHistBeneficiario = resolve('urlRequisitadoHistBeneficiario') + codServidor + '/' + seqDependenteRH;
      const { data } = await this.fetch(urlRequisitadoHistBeneficiario);
      data.map(res => {
        const { divisao, dtaInicio, dtaFim, situacao } = res;
        requisitado.push(Object.values({ divisao, dtaInicio, dtaFim, situacao }));
      });
      return requisitado || [];
    } catch (error) {
      console.error(error);
    }
  }  
  async consultarHistoricoSituacao (codServidor, seqDependenteRH) {
    let requisitado = [];
    try {
      const urlHistoricoSituacaoBeneficiario = resolve('urlHistoricoSituacaoBeneficiario') + codServidor + '/' + seqDependenteRH;
      const { data } = await this.fetch(urlHistoricoSituacaoBeneficiario);
      data.map(res => {
        const { divisao, dtaInicio, dtaFim, situacao } = res;
        requisitado.push(Object.values({ divisao, dtaInicio, dtaFim, situacao }));
      });
      return requisitado || [];
    } catch (error) {
      console.error(error);
    }
  }
  async salvarCartaoCaixa (numMatriculaTST, numCartaoCaixa) {
    const urlSalvarCartaoCaixa = resolve('urlSalvarCartaoCaixa') + numMatriculaTST + '/' + numCartaoCaixa;
    const response = await this.fetch(urlSalvarCartaoCaixa, 'put');
    return response;
  }
  async salvarCartaoUnimed (numMatriculaTST, numCartaoUnimed) {
    const urlSalvarCartaoUnimed = resolve('urlSalvarCartaoUnimed') + numMatriculaTST + '/' + numCartaoUnimed;
    const response = await this.fetch(urlSalvarCartaoUnimed, 'put');
    return response;
  }
  async executarMovimentacaoCnu (desTipoOperacao, numMatriculaTST) {
    const urlMovimentacaoCnu = resolve('urlMovimentacaoCnu') + desTipoOperacao + '/matricula' + '/' + numMatriculaTST;
    const response = await this.fetch(urlMovimentacaoCnu, 'post');
    return response;
  }  
}
export default BeneficiarioApi;
